import type { Permission } from 'paintscout'

export const PAINTER_CLIENT_INFO_PERMISSIONS: Permission[] = ['view:client-info']
export const PAINTER_PRICE_PERMISSIONS: Permission[] = ['view:job-value']
export const PAINTER_PAYMENT_PERMISSIONS: Permission[] = ['accept-payment:assigned-documents']
export const PAINTER_TASK_FILE_PERMISSIONS: Permission[] = ['contribute:assigned-deals']
export const PAINTER_ADDITIONAL_WORK_PERMISSIONS: Permission[] = ['additional-work:assigned-quotes']

// Base permissions always granted to painters (schedule view, assigned jobs, task reading)
export const PAINTER_BASE_PERMISSIONS: Permission[] = [
  'read:assigned-events',
  'read:assigned-quotes',
  'read:assigned-invoices',
  'read:assigned-tasks'
]

// All permissions for an employee painter (full access to all optional features)
export const PAINTER_EMPLOYEE_PERMISSIONS: Permission[] = [
  ...PAINTER_CLIENT_INFO_PERMISSIONS,
  ...PAINTER_PRICE_PERMISSIONS,
  ...PAINTER_PAYMENT_PERMISSIONS,
  ...PAINTER_TASK_FILE_PERMISSIONS,
  ...PAINTER_ADDITIONAL_WORK_PERMISSIONS
]

export const PAINTER_NOTIFICATION_TYPES = {
  jobAssigned: 'painter-job-assigned',
  jobUpdated: 'painter-job-updated',
  jobCancelled: 'painter-job-cancelled',
  // Always sent — cannot be disabled by the painter (PRD requirement)
  jobReassigned: 'painter-job-reassigned',
  // Task notifications share keys with the broader notification system.
  // taskDueDaily maps to 'task-overdue-daily' — the key the daily overdue-task
  // reminder cron (send-overdue-task-reminders) actually reads/sends. It matches
  // the office/Admin UserNotificationsForm's "overdue (daily reminder)" option.
  taskAssigned: 'task-assigned',
  taskDueDaily: 'task-overdue-daily',
  taskDueWeekly: 'task-upcoming-weekly'
}

export function getPainterAccountAccess(permissions: string[] = []) {
  return {
    canViewClientInfo: hasAnyPermission(permissions, PAINTER_CLIENT_INFO_PERMISSIONS),
    canViewPrices: hasAnyPermission(permissions, PAINTER_PRICE_PERMISSIONS),
    canManagePayments: hasAnyPermission(permissions, PAINTER_PAYMENT_PERMISSIONS),
    canViewTasksNotesFiles: hasAnyPermission(permissions, PAINTER_TASK_FILE_PERMISSIONS),
    canAddAdditionalWork: hasAnyPermission(permissions, PAINTER_ADDITIONAL_WORK_PERMISSIONS)
  }
}

function hasAnyPermission(permissions: string[], required: Permission[]) {
  return required.some((permission) => permissions.includes(permission))
}
